import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../lib/constants';

const SplashScreen = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showSplash && !loading) {
      if (isAuthenticated) {
        navigate(ROUTES.DASHBOARD);
      } else {
        navigate(ROUTES.LOGIN);
      }
    }
  }, [showSplash, loading, isAuthenticated, navigate]);

  return (
    // Added 'justify-between' and 'relative' to ensure footer and content never touch
    <div className="relative min-h-screen bg-gradient-to-br from-cream-100 via-cream-200 to-brown-100 flex flex-col items-center justify-center p-6 overflow-hidden">
      
      {/* Main Content Wrapper - Changed h-section to be more flexible */}
      <div className="w-full max-w-4xl mx-auto flex flex-col items-center animate-fade-in flex-1 justify-center mb-20">
        
        {/* Main Illustration Section - Made h-[35vh] for mobile to prevent overlap */}
        <div className="w-full h-[35vh] md:h-[50vh] flex items-center justify-center mb-6">
          <img 
            src="/book.png" 
            alt="OmniClarix Learning Illustration" 
            className="h-full w-auto object-contain drop-shadow-2xl transition-transform duration-1000 hover:scale-105"
          />
        </div>

        {/* Branding Section */}
        <div className="text-center space-y-2 mb-8">
          <h1 className="text-4xl md:text-7xl font-bold text-brown-900 tracking-tight">
            OmniClarix
          </h1>
          <p className="text-lg md:text-3xl text-brown-700 font-light">
            Clarity, Simplified.
          </p>
        </div>

        {/* Loading Indicator */}
        <div className="relative">
          <div className="w-10 h-10 md:w-12 md:h-12 border-4 border-brown-200 border-t-brown-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-brown-700 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Footer: Absolutely pinned, but safe from content due to mb-20 above */}
      <div className="absolute bottom-6 md:bottom-10 left-0 right-0 flex flex-col items-center gap-2 bg-transparent">
        <p className="text-[10px] font-bold text-brown-900/40 uppercase tracking-[0.2em]">
          © 2026 OmniClarix
        </p>
        <div className="h-[1px] w-6 bg-brown-900/10"></div>
        <p className="text-[9px] font-medium text-brown-800/40 uppercase tracking-widest">
          Built by <span className="text-brown-900/60 font-bold">Timi Dev</span>
        </p>
      </div>

    </div>
  );
};

export default SplashScreen;